import React from 'react';
import { ENetworkRequestStatus, IHotel } from 'services/BackendApi';
import * as Inputs from '../Inputs';
import { isUploadAnImage } from 'containers/HotelAdmin/utils';
import { Uploads } from '../Uploads';
import FluidButton from 'ui/FluidButton';
import { validateAmenities } from 'containers/HotelAdmin/validation';
import { enqueueNotification } from 'store/modules/ui';
import { useDispatch } from 'react-redux';

export const AmenitiesTab = ({
  hotel,
  onUpdate,
  onPatchHotel,
  patchingRequest,
}: {
  hotel: IHotel;
  onUpdate: (field: keyof IHotel, value: any) => void;
  onPatchHotel: (updatedData: Partial<IHotel>) => void;
  patchingRequest: ENetworkRequestStatus;
}) => {
  const dispatch = useDispatch();
  return (
    <div className="flex flex-col space-y-4 w-full">
      <Inputs.CrudList
        collection={hotel.amenities || []}
        className="w-full"
        onChange={newList => {
          onUpdate('amenities', newList);
        }}
      />
      <hr />
      <FluidButton
        type="primary"
        className="self-end w-[300px] mt-4"
        onClick={() => {
          const validation = validateAmenities(hotel as IHotel);
          if (validation.isValid === false) {
            dispatch(
              enqueueNotification({
                message: `Amenities are not valid: ${validation.message}`,
                options: { variant: 'warning' },
              })
            );
            return;
          }
          onPatchHotel({
            amenities: hotel.amenities,
          });
        }}
      >
        Update Amenities
      </FluidButton>
    </div>
  );
};
